/* unplugin-vue-components disabled */import script from "./localization.vue?vue&type=script&setup=true&lang=ts"
export * from "./localization.vue?vue&type=script&setup=true&lang=ts"

import "./localization.vue?vue&type=style&index=0&id=55662b86&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.9.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55662b86"]])

export default __exports__